namespace TotalPoll {
    import Service = TotalCore.Common.Service;

    @Service('services.totalpoll')
    export class RepositoryService {
        private resource;

        constructor($resource, private $httpParamSerializerJQLike, private prefix, private ajaxEndpoint, private pollId) {
            this.resource = $resource(ajaxEndpoint, {}, {
                list: {method: 'GET', cache: true, params: {poll: pollId}},
                polls: {method: 'GET', cache: true, isArray: true},
            });

            return this;
        }

        getDownload(format, filters = {}) {
            let iframe = document.createElement('iframe');
            let query = this.$httpParamSerializerJQLike(angular.extend({}, {action: `${this.prefix}_entries_download`, poll: this.pollId, format: format}, filters));
            iframe.src = `${this.ajaxEndpoint}?${query}`;
            iframe.width = '0';
            iframe.height = '0';
            document.body.appendChild(iframe);
        }

        getPage(page: number, filters = {}) {
            return this.resource
                .list(angular.extend({}, {action: `${this.prefix}_entries_list`, page: page}, filters))
                .$promise
                .then((response) => {
                    response['entries'] = response['entries'].map((entry) => {
                        return new Entry(entry);
                    });

                    return response;
                });
        }

        getPolls() {
            return this.resource
                .polls({action: 'totalpoll_entries_polls'})
                .$promise
        }
    }
}
